import isElectron from 'is-electron'
import compareVersions from 'compare-versions'

import paths from '../constants/deviceResourcePaths.js'
import { deviceVersions, asyncFetchBuffer, getBuffer, mergeTypedArrays, matchSensitivityPreset } from '../utilities'

import {
  DEVICE_UPDATE_FIRMWARE,
  FETCH_FIRMWARE,
  SET_PREVIOUS_FIRMWARE_VERSION,
  DEVICE_ENTER_BOOTLOADER,
  BOOTLOADER_READY,
  SEND_FIRMWARE,
  DEVICE_REQUEST_FIRMWARE_VERSIONS,
  DEVICE_REQUEST_PRESET,
  DEVICE_REQUEST_BUTTON_MODE,
  DEVICE_REQUEST_USER_CURVE,
  DEVICE_LOAD_PRESET_TO_BUFFER,
  DEVICE_SAVE_PRESET_TO_MEMORY,
  DEVICE_SAVE_USER_CURVE,
  DEVICE_SET_BUTTON_MODE,
  DEVICE_SET_BUTTON_MODES,
  DEVICE_SET_BAR_AVERAGE,
  DEVICE_SET_BAR_MULT,
  DEVICE_SEND_PRESET_TO_BUFFER,
  DEVICE_REQUEST_CROSSTALK_VELOCITY,
  DEVICE_SET_CROSSTALK_THRESHOLD,
  DEVICE_SET_GLOBAL_THRESHOLD,
  DEVICE_RESET,
  // bar regulation
  ENTER_LEARN_MODE,
  ENTER_NORMAL_MODE,
  DEVICE_REQUEST_ALL_BARS_TARES,
  DEVICE_REQUEST_ALL_BARS_AVERAGES,
  DEVICE_REQUEST_ALL_BARS_MULTS,
  DEVICE_REQUEST_GLOBAL_THRESHOLD,
  DEVICE_LEARN_MODE_RESET,
  
  // editor actions. should these be moved?
  CONNECT,
  DISCONNECT,
  RECONNECT,
  SET_FIRMWARE_UPDATE_AVAILABLE,
  FIRMWARE_UPDATE_COMPLETE,
  SET_FIRMWARE_VERSION,
  SET_PREFERENCE_UI_SYNC,
  SET_CROSSTALK_THRESHOLD,
  SET_GLOBAL_THRESHOLD,
  SET_CURRENT_PRESET,
  SELECT_PRESET,
  SET_BOOTLOADER_MODE
} from './actionTypes'

import {
  setUpdatesAvailable,
  setUserCurve,
  selectVelocityCurve,
  setStatusMessage,
  resetDevicePresetStore,
  devicePresetsLoaded,
  setRevertablePreset,
  storeBarsTare,
  storeBarAverages,
  storeBarMults,
  storeBarMult
} from '../actions/'
import { setSensitivityPreset } from './editorActions.js'

// Device Connections
export const deviceConnection = (status) => {
  return (dispatch, getState) => {
    const updatingFirmware = getState().device.updatingFirmware,
          learnModeOpen = getState().editor.learnModeOpen

    switch (status) {
      case 'connected':
        dispatch({ type: CONNECT })
        dispatch(enterNormalMode())
        if(!updatingFirmware) {
          dispatch(setStatusMessage(status))
          dispatch(requestFirmwareVersion())
        }
        dispatch(getButtonPresetMode())
        dispatch(resetDevicePresetStore())
        dispatch(requestPreset('1'))
        dispatch(requestPreset('2'))
        dispatch(requestPreset('3'))
        dispatch(requestPreset('4'))
        setTimeout(() => {
          if(getState().presets.device.length){
            // window.malletStation.loadPreset(1)
            dispatch({ type: SELECT_PRESET, selectedPreset: 'device-0' })
            dispatch({ type: SET_CURRENT_PRESET, preset: getState().presets.device[0] })
          }
          // get crosstalk
          dispatch(getCrosstalkThreshold())
          // get threshold
          dispatch(getGlobalThreshold())
          // check sensitivity preset
          setTimeout(() => {
            const sensitivityPreset = matchSensitivityPreset(getState()).then(preset => {
              dispatch(setSensitivityPreset(preset));
            })
          }, 500)
        }, 500)


        if(window.malletStation && window.malletStation.isConnected()) window.malletStation.editorConnect()
        break;
      case 'disconnected':
        dispatch({ type: DISCONNECT })
        dispatch(setStatusMessage(status))
        dispatch(devicePresetsLoaded(false))
        dispatch(resetDevicePresetStore())

        const presets = getState().presets
        let nextPreset, nextSelectPresetID

        if(presets.user.length) {
          nextSelectPresetID = 'user-0'
          nextPreset = { ...presets.user[0] }
        } else if(presets.factory.length) {
          nextSelectPresetID = 'factory-0'
          nextPreset = { ...presets.factory[0] }
        } else {
          // load what?
          // disable all UI?
        }
        dispatch({ type: SET_CURRENT_PRESET, preset: nextPreset })
        dispatch({ type: SELECT_PRESET, selectedPreset: nextSelectPresetID })
        dispatch(setRevertablePreset(false))
        dispatch(sendPreset(nextPreset))

        if(window.malletStation && window.malletStation.isConnected()) window.malletStation.editorDisconnect()
        break;
      case 'reconnected':
        dispatch({ type: RECONNECT })

        if(learnModeOpen) {
          console.log('>> malletStation Editor - Bar Regulation open: putting device in Bar Regulation mode');
          if(window.malletStation && window.malletStation.isConnected()) window.malletStation.setDeviceMode('learn');
          // re-request, merge, and store tares
          dispatch(requestAllBarTares(true))
          return
        } else {
          if(!updatingFirmware) {
            dispatch(setStatusMessage('connected'))
            dispatch(requestFirmwareVersion())
          }
          dispatch(getButtonPresetMode())
          dispatch(resetDevicePresetStore())
          // needed to request presets successfully on some systems
          setTimeout(() => {
            dispatch(requestPreset('1'))
            dispatch(requestPreset('2'))
            dispatch(requestPreset('3'))
            dispatch(requestPreset('4'))
          }, 500)

          setTimeout(() => {
            if(getState().presets.device.length){
              // window.malletStation.loadPreset(1)
              dispatch({ type: SELECT_PRESET, selectedPreset: 'device-0' })
              dispatch({ type: SET_CURRENT_PRESET, preset: getState().presets.device[0] })
            }
          }, 1000)
        }

        if(window.malletStation && window.malletStation.isConnected()) window.malletStation.editorConnect()
        break;
      case 'updatingfirmware':
        const availableFirmware = getState().device.availableFirmware
        dispatch({ type: DISCONNECT })
        dispatch(setStatusMessage(`updating firmware to ${availableFirmware.version}`))
        dispatch(devicePresetsLoaded(false))
        dispatch(resetDevicePresetStore())
        if(window.malletStation && window.malletStation.isConnected()) window.malletStation.editorDisconnect()
        break;
      default:

    }
  }
};

// Presets
export const requestPreset = (index) => {
  if(window.malletStation && window.malletStation.isConnected()) window.malletStation.getPreset(index)
  return { type: DEVICE_REQUEST_PRESET, index: index }
};

export const loadPreset = (memoryIndex) => {
  // if on-device preset : load flash preset to the edit buffer [1-4]
  if(window.malletStation && window.malletStation.isConnected()) window.malletStation.loadPreset(memoryIndex)
  return { type: DEVICE_LOAD_PRESET_TO_BUFFER }
};

export const sendPreset = (preset) => {
  // on preset select : editor to edit buffer
  if(window.malletStation && window.malletStation.isConnected()) window.malletStation.sendPreset(preset)
  return { type: DEVICE_SEND_PRESET_TO_BUFFER }
};

export const savePreset = (destination) => {
  return (dispatch) => {
    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.savePreset(destination)
    dispatch(resetDevicePresetStore())
    dispatch(requestPreset('1'))
    dispatch(requestPreset('2'))
    dispatch(requestPreset('3'))
    dispatch(requestPreset('4'))
    dispatch({ type: DEVICE_SAVE_PRESET_TO_MEMORY}) // edit buffer to slot
  }
};

// User Curves
export const requestUserCurve = (index) => {
  return (dispatch) => {
    if(window.malletStation && window.malletStation.isConnected()) {
      window.malletStation.once('usercurve', (paramObj) => {
        const [ curveIndex, curve ] = paramObj.values

        dispatch(setUserCurve(curveIndex, curve))
      })

      window.malletStation.getUserCurve(index)
    }

    dispatch({ type: DEVICE_REQUEST_USER_CURVE, index: index })
  }
};

export const saveUserCurve = (index, curve) => {
  return (dispatch) => {
    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.saveUserCurve(index, new Uint8Array(curve))
    dispatch({ type: DEVICE_SAVE_USER_CURVE, index: index, curve: curve })
    dispatch(setUserCurve(index, curve))
    dispatch(requestUserCurve('0'))
    dispatch(requestUserCurve('1'))
    dispatch(requestUserCurve('2'))
    dispatch(requestUserCurve('3'))
    dispatch(selectVelocityCurve(-1))
  }
};

// Button Preset Mode
export const getButtonPresetMode = () => {
  return (dispatch, getState) => {
    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.once('buttonpresetmode', (paramObj) => {
      const { values } = paramObj

      values.forEach((mode, index) => {
        dispatch({ type: DEVICE_SET_BUTTON_MODE, index: index, mode: mode })
      })
    })

    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.getButtonMode()
    dispatch({ type: DEVICE_REQUEST_BUTTON_MODE })
  }
};

export const setButtonPresetMode = (modes, index, mode) => {
  const updatedModes = [
    ...modes.slice(0, index),
    mode,
    ...modes.slice(index + 1)
  ]

  if(window.malletStation && window.malletStation.isConnected()) {
    window.malletStation.setButtonMode(updatedModes)
    window.malletStation.saveGlobals()
  }

  return { type: DEVICE_SET_BUTTON_MODE, index:index, mode: mode }
};

export const setButtonPresetModes = (modes) => {
  if(window.malletStation && window.malletStation.isConnected()) {
    window.malletStation.setButtonMode(modes)
    window.malletStation.saveGlobals()
  }

  return { type: DEVICE_SET_BUTTON_MODES }
};

// Firmware
export const setBootloaderMode = (active) => {
  return {
    type: SET_BOOTLOADER_MODE,
    active: active
  }
};

export const requestFirmwareVersion = () => {
  return (dispatch, getState) => {
    dispatch({ type: DEVICE_REQUEST_FIRMWARE_VERSIONS })

    if(window.malletStation && window.malletStation.isConnected()) {
      window.malletStation.once('firmwareversion', (versions) => {
        const { firmware: firmwareVersion, bootloader } = deviceVersions(versions),
              compatibleFirmwareVersion = getState().editor.minimumCompatibleVersion

        console.log(`>> malletStation: firmware ${firmwareVersion} bootloader ${bootloader}`);
        // only request presets if the device has the minimumCompatibleVersion: future feature from KBP4
        if(compareVersions(compatibleFirmwareVersion, firmwareVersion) < 1) {
          // future feature that prevents new preset from loading if device has incompatible firmware
          console.log('>> malletStation Editor: firmware compatible with editor')
          // getDevicePresets(dispatch, getState)
        } else {
          console.warn(`>> malletStation Editor: incompatible firmware v.${firmwareVersion} on your malletStation`);
          alert(`Firmware v.${firmwareVersion} is incompatible with this Editor.\nPlease update to v.${compatibleFirmwareVersion}`)
        }
        if(window.showFullVersions) console.log('malletStation:', versions);
        dispatch(setFirmwareVersion(deviceVersions(versions)))
        dispatch(setUpdateableFirmware(getState().device.availableFirmware.version, firmwareVersion))
      })

      window.malletStation.getFirmwareVersion()
    }
  }
};

export const setUpdateableFirmware = (availableFirmwareVersion, deviceFirmwareVersion) => {
  return (dispatch, getState) => {
    const editorUpdateAvailable = getState().editor.editorUpdateAvailable
    const firmwareUpdateAvailable = compareVersions(availableFirmwareVersion, deviceFirmwareVersion)

    // check if editor and fw available
    if (firmwareUpdateAvailable >= 0 && editorUpdateAvailable) {
      dispatch(setUpdatesAvailable())
    } else if (firmwareUpdateAvailable > 0) {
      setTimeout(() => {
        dispatch(setStatusMessage('firmware update available'))
      }, 1000)
      setTimeout(() => {
        dispatch(setStatusMessage(getState().device.connected ? 'connected' : 'disconnected'))
      }, 15000)
    } else if (editorUpdateAvailable > 0) {
      setTimeout(() => {
        dispatch(setStatusMessage('editor update available'))
      }, 1000)
      setTimeout(() => {
        dispatch(setStatusMessage(getState().device.connected ? 'connected' : 'disconnected'))
      }, 15000)
    }

    dispatch({
      type: SET_FIRMWARE_UPDATE_AVAILABLE,
      updateable: firmwareUpdateAvailable
    })
  }
}

export const setFirmwareVersion = (versions) => {
  return {
    type: SET_FIRMWARE_VERSION,
    versions: versions
  }
};

// request presets only if fw version is compatible
function getDevicePresets(dispatch, getState) {
  dispatch(resetDevicePresetStore())
  dispatch(requestPreset('1'))
  dispatch(requestPreset('2'))
  dispatch(requestPreset('3'))
  dispatch(requestPreset('4'))
  setTimeout(() => {
    if(getState().presets.device.length){
      dispatch({ type: SELECT_PRESET, selectedPreset: 'device-0' })
      dispatch({ type: SET_CURRENT_PRESET, preset: getState().presets.device[0] })
    }
  }, 500)
}


// after FW update, request firmware version
export const firmwareUpdateComplete = () => {
  const betaFirmwareVersion = '1.0.89'

  return (dispatch, getState) => {
    dispatch({type: FIRMWARE_UPDATE_COMPLETE})
    dispatch({ type: CONNECT })
    setTimeout(() => dispatch(setStatusMessage(`firmware update complete!`)), 4000)

    dispatch(setBootloaderMode(false))
    setTimeout(() => dispatch(requestFirmwareVersion()), 900)
    setTimeout(() => dispatch(setStatusMessage('connected')), 6000)

    setTimeout(() => {
      const firmwareVersion = getState().device.firmwareVersion,
            legacyFirmwareVersion = getState().device.legacyFirmwareVersion,
            previousFirmwareVersion = getState().device.previousFirmwareVersion

      console.log('>> malletStation Editor - current firmware version', firmwareVersion);
      console.log('>> malletStation Editor - previous firmware version', previousFirmwareVersion);

      if(previousFirmwareVersion <= legacyFirmwareVersion) {
        console.log('>> malletStation Editor - setting low / high bar averages to 15 / 200');
        window.malletStation.reset('averages')
        setTimeout(() => dispatch(setGlobalThreshold('1.15')), 200) // this is for updating the display only
        setTimeout(() => dispatch(setCrosstalkThreshold('5')), 400) // this is for updating the display only
      } else if(previousFirmwareVersion <= betaFirmwareVersion && previousFirmwareVersion > legacyFirmwareVersion) { // this is for beta tested units
        // set all mults to unity
        console.log('>> malletStation Editor - setting low & high to 1.00 and threshold mult to 1.00');
        if(previousFirmwareVersion <= betaFirmwareVersion) {
          window.malletStation.reset('mults')
          setTimeout(() => dispatch(setGlobalThreshold('1.15')), 200) // this is for updating the display only
          setTimeout(() => dispatch(setCrosstalkThreshold('5')), 400) // this is for updating the display only
        }
      }
    }, 1000)

    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.editorConnect()
  }
};

export const fetchFirmware = (url) => {
  if(url === null) {
    console.log('>> malletSTATION: could not fetch firmware due to a network issue');
    // disable FW button
    // set message
    // dispatch things
    return false
  }

  const networkConnection = navigator.onLine

  return (dispatch, getState) => {
    const internalFirmwarePath = getState().device.availableFirmware.url
    let firmwareRequest

    dispatch({type: DEVICE_UPDATE_FIRMWARE})
    dispatch({type: FETCH_FIRMWARE})
    dispatch({type: SET_PREVIOUS_FIRMWARE_VERSION, version: getState().device.firmwareVersion})

    if(isElectron()) {
      if(!networkConnection) {
        firmwareRequest = getBuffer(`./${internalFirmwarePath}`)
      } else {
        firmwareRequest = asyncFetchBuffer(paths.base+url)
      }
    } else {
      firmwareRequest = asyncFetchBuffer(paths.base+url)
    }

    firmwareRequest.then(firmwareBuffer => {
      console.log('>> malletStation: firmware downloaded');
      if(window.malletStation && (window.malletStation.isConnected() || window.malletStation.connection.bootloader.connected)){
        window.malletStation.once('bootloaderready', () => {
          dispatch({type:BOOTLOADER_READY})
          dispatch({type:SEND_FIRMWARE})
          console.log('>> malletStation: bootloader ready, sending firmware');
          window.malletStation.bootloader.send(new Uint8Array(firmwareBuffer))
        })

        window.malletStation.enterBootloader()
        dispatch({type:DEVICE_ENTER_BOOTLOADER})
      }
    })
    .catch(err => console.warn('>> malletStation: firmware download failed', err))
  }
};

// Device  reset
export const resetDevice = () => {
  return (dispatch) => {
    dispatch({type: DEVICE_RESET})
    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.reset()
      dispatch(getCrosstalkThreshold())
      dispatch(getGlobalThreshold())
    }
  }
}

// UI sync
export const toggleUISync = (active) => {
  return (dispatch) => {
    dispatch({type: SET_PREFERENCE_UI_SYNC, active: active})

    if(window.malletStation && window.malletStation.isConnected()){
      if(active) {
        window.malletStation.editorConnect()
      } else {
        window.malletStation.editorDisconnect()
      }
    }
  }
}

// crosstalk Cancellation Threshold
export const getCrosstalkThreshold = () => {
  return (dispatch) => {
    dispatch({ type: DEVICE_REQUEST_CROSSTALK_VELOCITY })
    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.once('crosstalkvelocityscale', (paramObj) => {
      const { values } = paramObj
      
      dispatch({ type: SET_CROSSTALK_THRESHOLD, value: values[0] })
    })

    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.getCrosstalkVelocity()
  }
};
export const setCrosstalkThreshold = (value) => {
  return (dispatch) => {
    dispatch({ type: DEVICE_SET_CROSSTALK_THRESHOLD, value: value })
    dispatch({ type: SET_CROSSTALK_THRESHOLD, value: value })

    // check sensitivity preset
    setTimeout(() => {
      const sensitivityPreset = matchSensitivityPreset(getState()).then(preset => {
        dispatch(setSensitivityPreset(preset))
      })
    }, 500)

    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.setCrosstalkVelocity(value) // save called in api
    }
  }
}

// Global Threshold Multiplier
export const getGlobalThreshold = () => {
  return (dispatch, getState) => {
    dispatch({ type: DEVICE_REQUEST_GLOBAL_THRESHOLD })
    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.once('thresholdmult', (paramObj) => {
      const { values } = paramObj
      dispatch({ type: SET_GLOBAL_THRESHOLD, value: values[0] })
    })

    if(window.malletStation && window.malletStation.isConnected()) window.malletStation.getGlobalThresholdMult()
  }
};
export const setGlobalThreshold = (value) => {
  return (dispatch) => {
    dispatch({ type: DEVICE_SET_GLOBAL_THRESHOLD, value: value })
    dispatch({ type: SET_GLOBAL_THRESHOLD, value: value })

    // check sensitivity preset
    setTimeout(() => {
      const sensitivityPreset = matchSensitivityPreset(getState()).then(preset => {
        dispatch(setSensitivityPreset(preset))
      })
    }, 500)
    

    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.setGlobalThresholdMult(value) // save called in api
    }
  }
}


// Normal Mode
export const enterNormalMode = () => {
  return (dispatch) => {
    dispatch({ type: ENTER_NORMAL_MODE })
    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.setDeviceMode('normal')
    }
  }
}

// Learn Mode
export const enterLearnMode = () => {
  return (dispatch) => {
    dispatch({ type: ENTER_LEARN_MODE })
    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.setDeviceMode('learn')
    }
  }
}

// Learn Mode Factory Reset
export const learnModeFactoryReset = () => {
  console.log('>> Bar Regulation : Factory Reset! bar averages and bar mults')
  return (dispatch) => {
    dispatch({ type: DEVICE_LEARN_MODE_RESET });
    if (window.malletStation && window.malletStation.isConnected()) {
      window.malletStation.reset("averages");
    }

    setTimeout(() => dispatch(sendBarMultsUnity('low')), 50);
    setTimeout(() => dispatch(sendBarMultsUnity('high')), 250);
  }
}

// : tare
export const requestAllBarTares = (merge=false) => {
  return (dispatch, getState) => {
    dispatch({ type: DEVICE_REQUEST_ALL_BARS_TARES, merge: merge })
    const strikeType = getState().editor.learnModeStrikeType

    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.once('tares', (paramObj) => {
        const tares = paramObj.values[0]
        if(merge && strikeType === 'soft'){
          const selectedLearnBar = getState().editor.selectedLearnBar,
              oldTare = getState().learnMode.tares

          const freshTares = mergeTypedArrays(oldTare, tares, selectedLearnBar)
          if(window.learnLog) {
            console.log('>> malletStation Editor: Bar Regulation - get new tares after power-cycle');
            console.log('>> malletStation Editor: Bar Regulation - oldTares:', oldTare);
            console.log('>> malletStation Editor: Bar Regulation - newTares:', tares);
            console.log('>> malletStation Editor: Bar Regulation - selectedLearnBar:', selectedLearnBar);
            console.log('>> malletStation Editor: Bar Regulation - freshTares:', freshTares);
          }
          dispatch(storeBarsTare(freshTares))
        } else {
          dispatch(storeBarsTare(tares))
        }

        if(tares.some(t => t >= 150)) console.warn('>> please contact support, your malletSTATION might need to be returned.')
      })

      window.malletStation.getBarTares()
    }
  }
}

// : average highs | lows
export const requestAllBarAverages = (mode = 'low') => {
  return (dispatch) => {
    dispatch({ type: DEVICE_REQUEST_ALL_BARS_AVERAGES })

    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.once(`baravg${mode}s`, (paramObj) => {
        const barAvgs = paramObj.values[0]
        dispatch(storeBarAverages(mode, barAvgs))
      })

      window.malletStation.getBarAverages(mode)
    }
  }
}

// : bar multipliers
export const requestAllBarMults = (mode = 'low') => {
  return (dispatch) => {
    dispatch({ type: DEVICE_REQUEST_ALL_BARS_MULTS, mode: mode })

    if(window.malletStation && window.malletStation.isConnected()){
      window.malletStation.once(`bar${mode}mults`, (paramObj) => {
        dispatch(storeBarMults(mode, paramObj.values[0]))
      })

      window.malletStation.getBarMults(mode)
    }
  }
}

// utility function for setting all mults to 1.00
export const sendBarMultsUnity = (mode = 'low', store = true) => {
  return (dispatch, getState) => {
    if(window.malletStation && window.malletStation.isConnected()){
      [...Array.from(Array(43).keys())].forEach(i => {
        window.malletStation.setBarMult(mode, i , '1.00')

        dispatch({
          type: DEVICE_SET_BAR_MULT,
          barIndex: i,
          mult: '1.00'
        })
        // resave 1.00 to store
        if(store) dispatch(storeBarMult(mode, i, '1.00'))
      })
    }
  }
}

// : data requests
export const requestAllDeviceData = () => {
  return (dispatch) => {

    setTimeout(() => {
      console.log('-->> request from device : store to editor: tares');
      dispatch(requestAllBarTares())
    }, 0)

    setTimeout(() => {
      console.log('-->> request from device : store to editor: average lows');
      dispatch(requestAllBarAverages('low'))
    }, 250)

    setTimeout(() => {
      console.log('-->> request from device : store to editor: average highs');
      dispatch(requestAllBarAverages('high'))
    }, 500)

    setTimeout(() => {
      console.log('-->> request from device : store to editor: bar-low mults');
      dispatch(requestAllBarMults('low'))
    }, 1250)

    setTimeout(() => {
      console.log('-->> request from device : store to editor: bar-high mults');
      dispatch(requestAllBarMults('high'))
    }, 1500)
  }
}

export const sendBarAverage = (mode, barIndex, avg) => {
  if(window.malletStation && window.malletStation.isConnected()) {

    if(window.learnLog) console.log(`>> send bar avg ${mode}: barIndex ${barIndex}, avg ${avg}`);
    window.malletStation.setBarAverage(mode, barIndex, avg) // save called in the API
  }

  return { type: DEVICE_SET_BAR_AVERAGE, mode: mode, bar: barIndex, average: avg }
}

export const sendBarMult = (mode='low', barIndex, barMult, save = true) => {
  if(window.malletStation && window.malletStation.isConnected()) {

    if(window.learnLog) console.log('>> send' + (save ? ' ' : ' temp ') + mode, 'bar', barIndex, 'barMult', barMult);
    window.malletStation.setBarMult(mode, barIndex, barMult, save)
  }

  return { type: DEVICE_SET_BAR_MULT, mode: mode, bar: barIndex, barMult: barMult }
};
